import { BREAKPOINTS } from './constants'

export const isBreakpoint = (index: number) => window.innerWidth >= parseInt(BREAKPOINTS[index], 10)



// WEBPACK FOOTER //
// ./src/styles/isBreakpoint.ts